import { Grid, Typography, withStyles, Button } from "@material-ui/core";

export const ButtonShadowed = withStyles((theme) => ({
  contained: {
    boxShadow:
      "0px 3px 5px -1px rgb(0 0 0 / 20%), 0px 5px 8px 0px rgb(0 0 0 / 14%), 0px 1px 14px 0px rgb(0 0 0 / 12%);",
  },
}))(Button);
